import { Card, CardHeader, Divider, Grid, useTheme } from '@mui/material';
import { Field, Formik } from 'formik';
import { TextField as FmTextFiled } from 'formik-mui';
import { useTranslation } from 'react-i18next';
import FieldEditorFooter from 'src/contents/profile-editor/FieldEditorFooter';
import {
  AddressFieldValue,
  TitledFieldValue
} from 'src/services/apiService/response-models';
import * as Yup from 'yup';
import { FieldRenderEditorProp } from '../..';
import getMultiFieldValue from '../../_utils/getMultiFieldValue';

export default function AddressBlockEditorRenderer(
  props: FieldRenderEditorProp
) {
  const { t }: { t: any } = useTranslation();
  const theme = useTheme();

  // useEffect(){

  // }
  const value = getMultiFieldValue<TitledFieldValue<AddressFieldValue>>(
    props,
    props.data.addresses
  );

  return (
    <>
      <Card>
        <CardHeader title={t(props.field.displayName)} />
        <Divider />
        <Formik
          initialValues={{
            title: value?.title || '',
            addressLine: value?.value?.addressLine || '',
            addressLine2: value?.value?.addressLine2 || '',
            city: value?.value?.city || '',
            state: value?.value?.state || '',
            zip: value?.value?.zip || '',
            country: value?.value?.country || ''
          }}
          validateOnBlur={false}
          validationSchema={Yup.object().shape({
            title: Yup.string().max(250),
            addressLine: Yup.string().max(250).required('Address is required'),
            addressLine2: Yup.string().max(250),
            city: Yup.string().required('City is required'),
            state: Yup.string().required('State is required'),
            zip: Yup.number().required('Zip is required'),
            country: Yup.string().required('Country is required')
          })}
          onSubmit={async (
            _values,
            { resetForm, setErrors, setStatus, setSubmitting }
          ) => {
            const addresses = [...(props.data.addresses || [])];
            addresses[props.valueIndex] = {
              title: _values.title,
              value: {
                addressLine: _values.addressLine,
                addressLine2: _values.addressLine2,
                city: _values.city,
                state: _values.state,
                zip: _values.zip,
                country: _values.country
              }
            };
            props.onSave({ ...props.data, addresses: addresses });
          }}
        >
          {({ handleSubmit, isSubmitting, values }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Grid sx={{ padding: theme.spacing(2) }} container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name={'addressLine'}
                    component={FmTextFiled}
                    label="Address Line 1"
                    placeholder={t('Enter here...')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name={'addressLine2'}
                    component={FmTextFiled}
                    label="Address Line 2"
                    placeholder={t('Enter here...')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name={'city'}
                    component={FmTextFiled}
                    label="City"
                    placeholder={t('Enter here...')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name={'state'}
                    component={FmTextFiled}
                    label="State"
                    placeholder={t('Enter here...')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name={'zip'}
                    component={FmTextFiled}
                    label="Zip"
                    placeholder={t('Enter here...')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name={'country'}
                    component={FmTextFiled}
                    label="Country"
                    placeholder={t('Enter here...')}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name={'title'}
                    component={FmTextFiled}
                    label="Title"
                    placeholder={t('Enter here...')}
                    // inputRef={(input) => {
                    //   input?.focus();
                    // }}
                  />
                </Grid>
              </Grid>
              <FieldEditorFooter
                onCancel={props.onCancel}
                onDelete={() => props.onDelete()}
              />
            </form>
          )}
        </Formik>
      </Card>
    </>
  );
}
